module.exports = __webpack_public_path__ + "static/media/triangle-border.fbce477e.svg";